import React from 'react';

const TimeLine = () => {
    return (
        <div className='py-6 '>
            <h1 className="text-2xl font-normal mb-2 gradient">
                <span className="text-primary font-bold">Provide_Best_Services </span>


            </h1>
            <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400 h1p">You will get 100% full service of work assured until you are fully satisfied.</p>

          <div className="grid lg:grid-cols-2 md:grid-cols-2 gap-6">
           <div className="">
                    <ol class="relative border-l border-gray-200 dark:border-gray-700">
                        <li class="mb-10 ml-4">
                            <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                            <h1 class="mb-1   leading-none text-gray-400 dark:text-gray-500 lg:text-2xl text-xl font-normal">Web Design</h1>

                            <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">I specialize in crafting responsive web designs, ensuring optimal viewing experiences across all devices. Recognizing the universal appeal of responsive design, I prioritize this aspect in all of my projects. Every piece of my work is centered around delivering a seamless responsive design. As developers, embracing and executing responsive design is an indispensable part of our role.</p>

                        </li>

                        <li class="mb-10 ml-4">
                            <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                            <h1 class="mb-1 text-xl  leading-none text-gray-400 dark:text-gray-500 lg:text-2xl font-normal">Frontend Development
                            </h1>

                            <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Crafting Digital Experiences with Next.js: Elevate your online presence with our tailored frontend development service. We're the architects behind captivating user interfaces, powered by the innovation of Next.js. Let's bring your ideas to life, pixel by pixel.</p>

                        </li>
                        <li class="mb-10 ml-4">
                            <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                            <h1 class="mb-1 text-xl  leading-none text-gray-400 dark:text-gray-500 lg:text-2xl font-normal">UI UX Design
                            </h1>

                            <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Shaping Digital Interactions: Unveil the beauty of user-centric design with our UI/UX expertise. We're the storytellers of seamless experiences, blending artistry and functionality into every click and swipe. Elevate your brand through thoughtful design that resonates with your audience.</p>

                        </li>


                    </ol>
           </div>
           <div className="">
                    <ol class="relative border-l border-gray-200 dark:border-gray-700">
                        <li class="mb-10 ml-4">
                            <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                            <h1 class="mb-1 text-xl   leading-none text-gray-400 dark:text-gray-500 lg:text-2xl font-normal">PSD/Figma To HTML</h1>

                            <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Transforming Vision into Reality: Witness your designs come alive as we seamlessly convert your PSD/Figma creations into pixel-perfect HTML. Our coding magic bridges the gap between imagination and user interaction, ensuring a web experience that's as stunning as your original vision.</p>

                        </li>

                        <li class="mb-10 ml-4">
                            <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                            <h1 class="mb-1 text-xl  leading-none text-gray-400 dark:text-gray-500 lg:text-2xl font-normal">MERN Application
                            </h1>

                            <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Unleashing Digital Dynamics: Introducing our MERN application expertise that marries MongoDB, Express, React, and Node.js into a harmonious symphony of innovation. From concept to deployment, we orchestrate your vision into a fully functional and captivating digital experience. </p>

                        </li>
                        <li class="mb-10 ml-4">
                            <div class="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                            <h1 class="mb-1 text-xl  leading-none text-gray-400 dark:text-gray-500 lg:text-2xl font-normal">Performance Optimization
                            </h1>

                            <p class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">Elevated SEO Optimization: Unlock the full potential of your application with SEO-friendly enhancements. Using the Next.js React framework, I'll ensure faster load times and heightened productivity. Your digital presence will shine brighter, attracting both users and search engines alike.</p>

                        </li>


                    </ol>
           </div>
          
          </div>
           

        </div>
    );
};

export default TimeLine;